export default "__VITE_ASSET__68e38ad5__"